import { sumSunLightRanges } from './sunLightUtils.js'

/**
 * Returns one of 13 insolation buckets for a product based on its total
 * direct sunlight hours.
 *
 * Buckets:
 *  'null'      — sun_light_ranges is null (measurement not available)
 *  '0'–'10'   — integer hours capped at 10 (10 = 10 h+)
 *
 * Total hours are computed by sumSunLightRanges — the same function used
 * everywhere else in the codebase for sun_light_ranges arrays.
 *
 * @param {[number, number][] | null | undefined} sun_light_ranges — product-level ranges array
 * @returns {'null'|'0'|'1'|'2'|'3'|'4'|'5'|'6'|'7'|'8'|'9'|'10'}
 */
export function getInsolationBucket(sun_light_ranges) {
  if (sun_light_ranges == null) return 'null'
  const hours = Math.min(10, Math.floor(sumSunLightRanges(sun_light_ranges)))
  return String(hours)
}
